/**
 * Mixed-content guard for dev URLs (Safari).
 *
 * The dev app is served over HTTPS (mkcert certs), but the .env dev fallbacks
 * point at plain http://localhost:* backends. Chrome treats http://localhost
 * as potentially trustworthy and allows it from an HTTPS page — Safari (macOS
 * AND iOS) blocks it as active mixed content, so every fetch/XHR/WebSocket
 * silently fails ("Load failed") and the app renders empty.
 *
 * When the page is HTTPS and the target is plain http://, route through the
 * page origin instead — the Vite dev proxy forwards /api, /data and /auth to
 * the Docker backends (see vite.config.ts). On staging/production both sides
 * are https, so this is a no-op. Works in window AND worker scope.
 */
export function httpsSafeUrl(url: string): string {
  try {
    if (globalThis.location?.protocol === 'https:' && url.startsWith('http://')) {
      return globalThis.location.origin
    }
  } catch (_) { /* no location (SSR/tests) — keep url as-is */ }
  return url
}
